import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class EmailServiceService {


  constructor(private http: HttpClient) { }
  commonURL: string = environment.api_URL;

  sendMail(data: any) {
    return this.http.post<any>(this.commonURL + 'send', data, {
      headers: {
        'x-api-key': environment.api_key,
      },
    });
  }
}
